import React, { Component } from 'react';

import './KMLAttributeOptionList.css'
export class KMLAttributeOptionList extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className='KMLAttributeOptionList' style={{ maxHeight: this.props.height }}>
                <div style={{ fontWeight: 'bold' }}>屬性欄位：</div>
                {
                    Object.keys(this.props.data).map((item)=>{
                        return (
                            <div key={item}>
                                <input type="checkbox" id={item} name={item} value={item} checked={this.props.data[item]} onChange={this.handleCheckBoxChanged}/>
                                <label>{item}</label>
                            </div>
                        );
                    })
                }                           
            </div>
        );
    }   

    handleCheckBoxChanged = (e) => {
        this.props.onAttributesChange({name: e.target.value, show: e.target.checked});        
    }

   
}